export default (): void => {
  const headerElement: Element | null = document.querySelector('#header-monolit')
  if (headerElement?.classList.contains('mn-header-fixed')) {
    document.body.style.paddingTop = `${headerElement?.clientHeight}px`
  }
}
